import { useShopGoogleAnalytics as w } from "./useShopGoogleAnalytics.js";
import { useShopFBAnalytics as A } from "./useShopFBAnalytics.js";
function F(e, { marketingConsent: x = !1 } = {}) {
  var h, R, v, i, k;
  const { settings: t, checkout: d } = e ?? {}, s = (h = e == null ? void 0 : e.settings.analytics) == null ? void 0 : h.getCodes(), a = x ? s == null ? void 0 : s.pixel : void 0, {
    isReady: l
  } = w(
    s == null ? void 0 : s.ga,
    s == null ? void 0 : s.gtm
  ), {
    isReady: I
  } = A(a, t == null ? void 0 : t.shop), S = () => {
    var p, y;
    return ((y = (p = d == null ? void 0 : d.ticket) == null ? void 0 : p.ticketItemList) == null ? void 0 : y.map((m) => {
      var o, E;
      return {
        id: m.itemId,
        quantity: m.quantity,
        amount: m.getTotal(),
        currency: d.ticket.ticketSummary.currency,
        brand: (o = t == null ? void 0 : t.shop) == null ? void 0 : o.url,
        // eslint-disable-next-line no-underscore-dangle
        category: ((E = d.shopTicket.dishes.find((r) => r._id === m.itemId)) == null ? void 0 : E.category_name) ?? ""
      };
    })) ?? [];
  }, c = () => ({
    id: t == null ? void 0 : t.shop.id,
    ticket: d == null ? void 0 : d.ticket,
    items: S()
  });
  return {
    analytics: {
      dispatchEvent: (p, y = {}) => {
        window.dispatchEvent(
          new CustomEvent(p, {
            detail: {
              ...c(),
              ...y
            }
          })
        );
      },
      getEventData: c,
      ga: {
        isReady: l,
        code: (v = (R = e == null ? void 0 : e.settings.analytics) == null ? void 0 : R.google) == null ? void 0 : v.ga
      },
      gtm: {
        isReady: l,
        code: (k = (i = e == null ? void 0 : e.settings.analytics) == null ? void 0 : i.google) == null ? void 0 : k.gtm
      },
      facebookPixel: {
        isReady: I,
        code: a
      }
    }
  };
}
export {
  F as useShopAnalytics
};
//# sourceMappingURL=useShopAnalytics.js.map
